module.exports = __webpack_public_path__ + "img/index-tj2.e0d23680.png";